export const HOME = '/';
export const LANDING_PAGE = '/landing-page';
export const FAQ_PAGE_PATH = '/faq';
export const GET_STARTED_PATH = '/get-started';
export const TERMS_PATH = '/terms';
export const PRIVACY_NOTICE_PATH = 'https://www.amazon.com/gp/help/customer/display.html?ie=UTF8&nodeId=201909010';
export const TERMS_CONDITIONS_OF_USE_PATH = '/terms#conditionsOfUse';
export const PRIVACY_POLICY_PATH = '/privacy-notice';
export const CONDITIONS_OF_USE_FOR_EXTERNAL_APP = 'https://www.amazon.fr/gp/help/customer/display.html?nodeId=201909000&ref_=footer_cou';
export const HELP_PAGE = 'https://www.amazon.com/gp/help/customer/display.html';
export const CUSTOMER_SERVICE_PAGE = 'https://www.amazon.com/gp/help/customer/account-issues/ref=ap_cs_forgot_pwd?ie=UTF8';
export const EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED = 'carrierhub';
export const EXTERNAL_PASSPORT_APP_DOMAIN = 'carrierlogistics';
export const EXTERNAL_PASSPORT_APP_DOMAINS = [
  EXTERNAL_PASSPORT_APP_DOMAIN,
  EXTERNAL_PASSPORT_APP_DOMAIN_DEPRECATED,
];
export const CMS_PATH = "/dashboard/cms"
export const PROFILE_PAGE = '/profile';
export const MANAGE_USERS_PAGE = '/account/permissions';
export const AUTH_PORTAL_FOOTER_PATH = '/gp/';
export const FORECAST_PATH = '/logisticsProviders/:lpId/forecast';
export const APP_INVITATION_PATH = '/invitation';
export const PARTNER_PICKER_PATH = '/dashboard/forecast';
export const USER_SESSION_API_PATH = '/user';

export const NPC_PATH = '/dashboard/performance-management';
export const DEFAULT_USER_AUTHENTICATED_PAGE = LANDING_PAGE;

export const CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH = '/dashboard/capacity-management';

export const REPORTS_SHARING_PATH = '/reports/:reportTermPath/:reportTypePath';

export const PAM_PATH = '/account/manage-permissions/:customerId';

export const PICKER_PATH = '/global-picker';

export const ACCOUNTS_PATH = '/account';

export const CASE_MANAGEMENT_PATH = '/dashboard/case-management';

export const PERFORMANCE_INSIGHTS_PATH = '/dashboard/performance-insights';

export const PERFORMANCE_DASHBOARD_PATH = '/dashboard/performance-dashboard';

export const CSAT_SURVEY_PATH = '/feedback/survey';

export const RUBIKS_PATH = '/dashboard/problem-solve';
